import React from "react";
import { Route } from "react-router-dom";
import MarketingViewRoute from "./marketing";
import ProgramTypeRoute from "./program-type";
import ValueRankingRoute from "./value-ranking";

export default function MarketingRoutes( props ) {
    return (
    <Route path="/marketing">
       {MarketingViewRoute(props)}
       {ProgramTypeRoute(props)}
       {ValueRankingRoute(props)}
    </Route>
    )
}